/* Foulée — scripts communs : argent, tiroirs, recherche, panier AJAX, annonce. */
window.theme = window.theme || {};

theme.formatMoney = (cents, format = theme.moneyFormat || '{{amount_with_comma_separator}} €') => {
  const value = Number(cents) / 100;
  const fmt = (n, dec, thousands, decimal) => {
    const [int, frac] = n.toFixed(dec).split('.');
    return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
  };
  return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => ({
    amount: fmt(value, 2, ',', '.'),
    amount_no_decimals: fmt(value, 0, ',', '.'),
    amount_with_comma_separator: fmt(value, 2, '.', ','),
    amount_no_decimals_with_comma_separator: fmt(value, 0, '.', ','),
    amount_with_space_separator: fmt(value, 2, ' ', ','),
    amount_with_apostrophe_separator: fmt(value, 2, "'", '.')
  }[key] ?? fmt(value, 2, ',', '.')));
};

theme.toast = (message) => {
  const el = document.getElementById('Toast');
  if (!el) return;
  el.textContent = message;
  el.classList.add('is-visible');
  clearTimeout(theme.toast.timer);
  theme.toast.timer = setTimeout(() => el.classList.remove('is-visible'), 3500);
};

/* Tiroirs */
let lastFocus = null;
theme.openDrawer = (id) => {
  const drawer = document.getElementById(id);
  if (!drawer) return;
  lastFocus = document.activeElement;
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  document.documentElement.classList.add('no-scroll');
  document.querySelectorAll(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
  const focusable = drawer.querySelector('button, a, input');
  focusable && focusable.focus();
};
theme.closeDrawers = () => {
  document.querySelectorAll('.drawer.is-open').forEach((d) => {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.querySelectorAll(`[aria-controls="${d.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
  });
  document.documentElement.classList.remove('no-scroll');
  lastFocus && lastFocus.focus && lastFocus.focus();
};

document.addEventListener('click', (e) => {
  const opener = e.target.closest('[data-drawer-open]');
  if (opener) { e.preventDefault(); theme.openDrawer(opener.dataset.drawerOpen); return; }
  if (e.target.closest('[data-drawer-close]')) { theme.closeDrawers(); return; }
  const cartLink = e.target.closest('[data-cart-open]');
  if (cartLink && theme.cartType === 'drawer' && !document.querySelector('[data-cart-page]')) {
    e.preventDefault();
    theme.openDrawer('CartDrawer');
    return;
  }
  if (e.target.closest('[data-search-open]')) {
    const modal = document.getElementById('SearchModal');
    modal.showModal();
    modal.querySelector('input[type="search"]').focus();
    return;
  }
  if (e.target.closest('[data-search-close]')) document.getElementById('SearchModal').close();
});
document.addEventListener('keydown', (e) => { if (e.key === 'Escape') theme.closeDrawers(); });

/* Menus déroulants desktop : un seul ouvert, fermé au clic extérieur */
document.addEventListener('click', (e) => {
  document.querySelectorAll('[data-dropdown][open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
});
document.querySelectorAll('[data-dropdown]').forEach((d) => d.addEventListener('toggle', () => {
  if (d.open) document.querySelectorAll('[data-dropdown][open]').forEach((o) => { if (o !== d) o.removeAttribute('open'); });
}));

/* Panier AJAX */
theme.cart = {
  sections: 'cart-drawer',
  async request(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: this.sections, sections_url: window.location.pathname })
    });
    let data = null;
    try { data = await res.json(); } catch (_) { /* réponse non JSON (ex. 429) */ }
    if (!res.ok || !data) {
      const message = (data && (data.description || data.message)) || 'Réessayez dans un instant.';
      throw new Error(message);
    }
    return data;
  },
  render(data) {
    const html = data.sections && data.sections['cart-drawer'];
    if (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-drawer]');
      const current = document.querySelector('[data-cart-drawer]');
      if (fresh && current) {
        const wasOpen = current.classList.contains('is-open');
        current.innerHTML = fresh.innerHTML;
        if (wasOpen) current.classList.add('is-open');
      }
      const count = doc.querySelector('[data-cart-count-source]');
      if (count) theme.cart.setCount(Number(count.textContent));
    }
  },
  setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = n; el.hidden = n === 0; });
  },
  async add(item) {
    const data = await this.request(theme.routes.cartAdd + '.js', { items: [item] });
    const withCode = await this.applyAutoCode();
    if (theme.cartType === 'page') { window.location.href = theme.routes.cart; return data; }
    this.render(withCode || data);
    theme.openDrawer('CartDrawer');
    return data;
  },
  /* Code promo automatique : Réglages du thème > Panier. Un échec ne bloque jamais l'ajout. */
  async applyAutoCode() {
    if (!theme.autoDiscount) return null;
    try {
      return await this.request(theme.routes.cartUpdate + '.js', { discount: theme.autoDiscount });
    } catch (_) {
      return null;
    }
  },
  async change(line, quantity) {
    const data = await this.request(theme.routes.cartChange + '.js', { line, quantity });
    if (document.querySelector('[data-cart-page]')) { window.location.reload(); return data; }
    this.render(data);
    return data;
  }
};

/* Panier déjà rempli sans le code (retour sur le site, ajout hors du thème) : on l'applique une seule fois */
if (theme.cartNeedsCode && !sessionStorage.getItem('autoCodeTried')) {
  sessionStorage.setItem('autoCodeTried', '1');
  theme.cart.applyAutoCode().then((data) => {
    if (!data) return;
    if (document.querySelector('[data-cart-page]')) window.location.reload();
    else theme.cart.render(data);
  });
}

/* Quantités et suppression (tiroir + page panier) */
document.addEventListener('click', async (e) => {
  const line = e.target.closest('.cart-item');
  if (!line) return;
  const input = line.querySelector('[data-qty-input]');
  let qty = null;
  const step = e.target.closest('[data-qty-change]');
  if (step) qty = Math.max(0, Number(input.value) + Number(step.dataset.qtyChange));
  if (e.target.closest('[data-remove]')) qty = 0;
  if (qty === null) return;
  line.classList.add('is-loading');
  try {
    await theme.cart.change(Number(line.dataset.line), qty);
  } catch (err) {
    line.classList.remove('is-loading');
    theme.toast(err.message);
  }
});
document.addEventListener('change', async (e) => {
  const input = e.target.closest('[data-qty-input]');
  if (!input) return;
  const line = input.closest('.cart-item');
  line.classList.add('is-loading');
  try {
    await theme.cart.change(Number(line.dataset.line), Math.max(0, Number(input.value) || 0));
  } catch (err) {
    line.classList.remove('is-loading');
    theme.toast(err.message);
  }
});

/* Formulaires qui se soumettent seuls (tri, filtres) */
document.addEventListener('change', (e) => {
  const el = e.target.closest('[data-auto-submit]');
  if (el) (el.form || el.closest('form')).requestSubmit();
});

/* Barre d'annonce : rotation des messages */
document.querySelectorAll('[data-announcement]').forEach((bar) => {
  const items = [...bar.children];
  if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let i = 0;
  setInterval(() => {
    items[i].hidden = true;
    i = (i + 1) % items.length;
    items[i].hidden = false;
  }, 4500);
});

/* En-tête : repasse en blanc dès qu'on scrolle */
(() => {
  const header = document.querySelector('.site-header');
  if (!header) return;
  const hero = document.querySelector('.hero');
  const mobile = window.matchMedia('(max-width: 989px)');
  const update = () => {
    const overlay = document.documentElement.classList.contains('header-overlay');
    /* Mobile et tablette : logo transparent tant que l'en-tête est sur la bannière */
    const onHero = overlay && mobile.matches && hero && hero.getBoundingClientRect().bottom > header.offsetHeight;
    header.classList.toggle('is-scrolled', onHero ? false : window.scrollY > 10);
    header.classList.toggle('is-moved', window.scrollY > 10);
  };
  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
})();

/* Carrousel des modèles : flèches + barre de progression */
document.querySelectorAll('[data-model-slider]').forEach((root) => {
  const track = root.querySelector('[data-model-track]');
  const prev = root.querySelector('[data-model-prev]');
  const next = root.querySelector('[data-model-next]');
  const bar = root.querySelector('[data-model-bar]');
  if (!track) return;
  const update = () => {
    const max = track.scrollWidth - track.clientWidth;
    const share = track.clientWidth / track.scrollWidth;
    bar.style.width = `${share * 100}%`;
    bar.style.left = max > 0 ? `${(track.scrollLeft / max) * (100 - share * 100)}%` : '0';
    prev.disabled = track.scrollLeft <= 1;
    next.disabled = track.scrollLeft >= max - 1;
  };
  const step = (dir) => {
    const card = track.firstElementChild;
    if (!card) return;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const size = card.getBoundingClientRect().width + gap;
    const perPage = Math.max(1, Math.floor((track.clientWidth + gap) / size));
    track.scrollBy({ left: dir * perPage * size, behavior: 'smooth' });
  };
  prev.addEventListener('click', () => step(-1));
  next.addEventListener('click', () => step(1));
  track.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
});
